var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":12}},[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("申请-专业分布")])]),_c('div',{style:({ height: '330px' }),attrs:{"id":"myChartSpe"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }